module.exports = __webpack_public_path__ + "static/media/us.50de7dfa.svg";